export var getParams = function () {
    return new URLSearchParams(window.location.search);
};
